import React, { useState } from 'react';
import { X, Menu } from 'lucide-react';

const ResponsiveNavbar: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-sm shadow-sm z-50 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          {/* <a href='/' className="flex items-center space-x-2">
            <div className="w-10 h-10 rounded-xl overflow-hidden flex items-center justify-center">
              <img
                src="logo.png"
                alt="CFL Global Logistics"
                className="w-full h-full object-contain"
              />
            </div>
            <span className="text-xl font-bold text-gray-900">CFL Global</span>
          </a> */}




          <a href='/' className="flex items-center space-x-2">
            <img
              src="logo.png"
              alt="CFL Global Logistics"
              className="w-50 h-12 rounded-xl object-contain"
            />
            {/* <span className="text-xl font-bold text-gray-900">CFL Global</span> */}
          </a>



          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8">
            <a href="/" className="text-gray-700 hover:text-red-600 transition-colors font-medium">
              Home
            </a>
            <a href="/about-us" className="text-gray-700 hover:text-red-600 transition-colors font-medium">
              About Us
            </a>
            <a href="/services" className="text-gray-700 hover:text-red-600 transition-colors font-medium">
              Our Services
            </a>
            <a href="/tracking" className="text-gray-700 hover:text-red-600 transition-colors font-medium">
              Tracking
            </a>
            <a href="/contact-us" className="text-gray-700 hover:text-red-600 transition-colors font-medium">
              Contact Us
            </a>
          </div>

          {/* Desktop CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <a
              href="/quote"
              className="bg-gradient-to-r from-red-600 to-red-700 text-white px-6 py-2 rounded-lg font-semibold hover:from-red-700 hover:to-red-800 transition-all duration-300 shadow-sm"
            >
              Get Quote
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMobileMenu}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="Toggle mobile menu"
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-gray-700" />
            ) : (
              <Menu className="w-6 h-6 text-gray-700" />
            )}
          </button>
        </div>

        {/* Mobile Navigation Menu */}
        <div className={`md:hidden absolute top-full left-0 right-0 transition-all duration-300 ease-in-out ${isMobileMenuOpen
          ? 'opacity-100 visible translate-y-0'
          : 'opacity-0 invisible -translate-y-2'
          }`}>
          <div className="mx-4 mt-2 bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
            <div className="py-2">
              <a
                href="/"
                onClick={closeMobileMenu}
                className="flex items-center px-6 py-4 text-gray-700 hover:text-red-600 hover:bg-red-50 transition-all duration-200 font-medium border-b border-gray-50 last:border-b-0"
              >
                Home
              </a>
              <a
                href="/about-us"
                onClick={closeMobileMenu}
                className="flex items-center px-6 py-4 text-gray-700 hover:text-red-600 hover:bg-red-50 transition-all duration-200 font-medium border-b border-gray-50 last:border-b-0"
              >
                About Us
              </a>
              <a
                href="/services"
                onClick={closeMobileMenu}
                className="flex items-center px-6 py-4 text-gray-700 hover:text-red-600 hover:bg-red-50 transition-all duration-200 font-medium border-b border-gray-50 last:border-b-0"
              >
                Our Services
              </a>
              <a
                href="/tracking"
                onClick={closeMobileMenu}
                className="flex items-center px-6 py-4 text-gray-700 hover:text-red-600 hover:bg-red-50 transition-all duration-200 font-medium border-b border-gray-50 last:border-b-0"
              >
                Tracking
              </a>
              <a
                href="/contact-us"
                onClick={closeMobileMenu}
                className="flex items-center px-6 py-4 text-gray-700 hover:text-red-600 hover:bg-red-50 transition-all duration-200 font-medium"
              >
                Contact Us
              </a>
            </div>

            {/* Mobile CTA Button */}
            <div className="p-4 bg-gray-50 border-t border-gray-100">
              <a
                href="/quote"
                onClick={closeMobileMenu}
                className="block w-full text-center bg-gradient-to-r from-red-600 to-red-700 text-white px-6 py-3 rounded-xl font-semibold hover:from-red-700 hover:to-red-800 transition-all duration-300 shadow-lg"
              >
                Get Quote
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div
          className="md:hidden fixed inset-0 bg-black/20 z-30"
          onClick={closeMobileMenu}
        />
      )}
    </nav>
  );
};

export default ResponsiveNavbar;